import { BLOG_COMMON_COMP_ID } from '@wix/communities-blog-client-common/dist/src/constants/components';
import { parseAppSettings } from '../services/parse-app-settings';
import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const FETCH_COMMON_SETTINGS_REQUEST = 'commonSettings/FETCH_REQUEST';
export const FETCH_COMMON_SETTINGS_SUCCESS = 'commonSettings/FETCH_SUCCESS';
export const FETCH_COMMON_SETTINGS_FAILURE = 'commonSettings/FETCH_FAILURE';

export const fetchCommonSettingsRequest = createAction(FETCH_COMMON_SETTINGS_REQUEST);
export const fetchCommonSettingsSuccess = createAction(FETCH_COMMON_SETTINGS_SUCCESS);
export const fetchCommonSettingsFailure = createAction(FETCH_COMMON_SETTINGS_FAILURE);

export function fetchCommonSettings(params) {
  return (dispatch, getState, { request }) => {
    dispatch(fetchCommonSettingsRequest());

    const { viewMode, externalId } = parseAppSettings(params, getState());
    const promise = request.metered('/_api/settings#compId&externalId&viewMode')(
      `/_api/settings?compId=${BLOG_COMMON_COMP_ID}&externalId=${externalId}&viewMode=${viewMode}`,
    );
    return promise
      .then(settings => dispatch(fetchCommonSettingsSuccess(settings)))
      .catch(() => dispatch(fetchCommonSettingsFailure()))
      .then(() => promise);
  };
}
